import { ICON_MAP } from '../../utils/iconRegistry';

export default function IconUI({
  icon = 'arrowDown',
  size = 'regular',
  theme = 'transparent',
  padding = false,
  children,
}) {
  const className = `icon icon--${theme} ${padding ? 'icon--padding' : ''}`;

  // `children` bypasses the registry so a consumer can drop a non-SVG icon
  // (e.g. the animated <IconPlus />) into the same circular chrome.
  if (children) {
    return (
      <span className={className} data-size={size}>
        {children}
      </span>
    );
  }

  const IconComponent = ICON_MAP[icon];

  if (!IconComponent) {
    console.warn(`Icon "${icon}" not found in registry`);
    return null;
  }

  // Stroke width is set in CSS (1.5 mobile / 2 desktop) rather than via an
  // `isDesktop` prop here — a JS breakpoint value baked into the SSR markup
  // caused hydration mismatches. See assets/styles/fragments/_icons.scss.
  return (
    <span className={className} data-size={size}>
      <IconComponent />
    </span>
  );
}
